'use client';

import 'react-phone-input-2/lib/high-res.css';

import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Form, FormControl, InputGroup, Overlay, Row, Spinner, Toast } from 'react-bootstrap';
import { CountryDropdown } from 'react-country-region-selector';
import ReCAPTCHA from 'react-google-recaptcha';
import PhoneInput from 'react-phone-input-2';
import Section3 from '../home/Section3';
import { useMediaQuery } from '@uidotdev/usehooks';
import counties from './assets/country_tel_code.json';
import { useParams, useRouter, useSearchParams } from 'next/navigation';
import { useTranslation } from '@/i18n/client';
import { Locale } from '../../../../i18n-config';
import { isPhoneNumberValid, resolveCountryCode } from '@/utils/phoneValidation';

const c1 = '/images/c1.webp';
const c10 = '/images/c10.webp';
const c2 = '/images/c2.webp';
const c3 = '/images/c3.webp';
const c4 = '/images/c4.webp';
const c5 = '/images/c5.webp';
const c6 = '/images/c6.webp';
const c7 = '/images/c7.webp';
const c8 = '/images/c8.webp';
const c9 = '/images/c9.webp';
const banner = '/images/Iranjourney-contact_us_form-iran_journey-_TIMNAK-iran_tours-_iran_custom_tours.webp';

const Client = () => {
  const { lang } = useParams();
  const { t } = useTranslation(lang as Locale);
  const router = useRouter();
  const searchParams = useSearchParams();

  const recaptchaRef = useRef<any | null>(null);
  const target = useRef(null);

  const isMobile = useMediaQuery('only screen and (max-width : 768px)');
  const isBigScreen = useMediaQuery('only screen and (min-width : 993px) and (max-width : 1200px)');

  const [counter, setCounter] = useState(1);
  const [counter2, setCounter2] = useState(5);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');
  const [nationality, setNationality] = useState('');
  const [travelingmonth, setTravelingMonth] = useState('');
  const [groupsize] = useState('');
  const [accommodation, setAccommodation] = useState('N');
  const [message, setMessage] = useState('');
  const [validname, setValidname] = useState(false);
  const [validemail, setValidemail] = useState(false);
  const [validtel, setValidtel] = useState(false);
  const [validnationality, setValidNationality] = useState(false);
  const [validtravelingmonth, setValidTravelingMonth] = useState(false);
  const [, setValidGroupSize] = useState(false);
  const [validaccommodation, setValidAccomodation] = useState(false);
  const [validmessage, setValidmessage] = useState(false);
  const [countrynumber, setCountrynymber] = useState('gb');
  const [trip_code, setTripCode] = useState(searchParams.get('code') || '');
  const [show, setShow] = useState(false);
  const [show_message, setShowMessage] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitCustomtour = (e) => {
    e.preventDefault();
    recaptchaRef.current.execute();
    setIsSubmitting(true);

    const custom_tour = {
      trip_code: trip_code,
      name: name,
      email: email,
      country: countrynumber.toUpperCase(),
      phone_number: tel,
      traveling_month: travelingmonth,
      duration: counter2,
      group_size: counter,
      level_of_accommodation: accommodation,
      note: message,
    };

    axios
      .post(`https://api.iranjourney.com/api/contact/custom_tour/create`, custom_tour)
      .then((res) => {
        RestoreCustomTour();
        setShowSuccessToast(true);
        setTimeout(() => router.push(`/${lang}/successful-submit`), 1200);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const RestoreCustomTour = () => {
    setName('');
    setNationality('');
    setTel('');
    setEmail('');
    setMessage('');
    setTravelingMonth('');
    setAccommodation('');
  };

  const selectCountry = (val) => {
    const resolvedCountryCode = resolveCountryCode(val);
    setCountrynymber(resolvedCountryCode || 'gb');
    setNationality(val);
  };

  const checkValids = useCallback(() => {
    return !(
      validname &&
      validemail &&
      validtel &&
      validnationality &&
      validtravelingmonth &&
      // validaccommodation &&
      validmessage
    );
  }, [validemail, validmessage, validname, validnationality, validtel, validtravelingmonth]);

  useEffect(() => {
    checkValids();
  }, [checkValids]);

  useEffect(() => {
    if (name.length > 2 && name.match('^[a-zA-Z ]*$') != null) {
      setValidname(true);
    } else {
      setValidname(false);
    }
  }, [name]);

  useEffect(() => {
    let firstsent = email.lastIndexOf('@');
    let middlesent = email.lastIndexOf('.');

    if (firstsent >= 3 && middlesent - firstsent >= 4 && email.length - middlesent >= 3) {
      setValidemail(true);
    } else {
      setValidemail(false);
    }
  }, [email]);

  useEffect(() => {
    setValidtel(isPhoneNumberValid(tel, countrynumber));
  }, [tel, countrynumber]);

  useEffect(() => {
    if (travelingmonth.length > 2 && travelingmonth.match('^[a-zA-Z ]*$') != null) {
      setValidTravelingMonth(true);
    } else {
      setValidTravelingMonth(false);
    }
  }, [travelingmonth]);

  useEffect(() => {
    if (nationality.trim().length > 2) {
      setValidNationality(true);
    } else {
      setValidNationality(false);
    }
  }, [nationality]);

  useEffect(() => {
    if (groupsize.length > 2 && groupsize.match('^[a-zA-Z ]*$') != null) {
      setValidGroupSize(true);
    } else {
      setValidGroupSize(false);
    }
  }, [groupsize]);

  useEffect(() => {
    if (accommodation.length > 2) {
      setValidAccomodation(true);
    } else {
      setValidAccomodation(false);
    }
  }, [accommodation]);

  useEffect(() => {
    if (message.length > 2) {
      setValidmessage(true);
    } else {
      setValidmessage(false);
    }
  }, [message]);

  useEffect(() => {
    axios
      .get('https://ipapi.co/json/')
      .then((response) => {
        let data = response.data;
        counties.map((country) => {
          if (data.country_name === country.name) {
            setNationality(data.country_name);
          }
        });

        setCountrynymber(data.country_code.toLowerCase());
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    if (searchParams.has('code')) {
      setTripCode(searchParams.get('code') as string);
      setShow(true);
      setShowMessage(true);
    }
  }, [searchParams]);

  return (
    <div className="tw-mt-[66px]">
      <div
        style={
          isBigScreen
            ? {
                backgroundImage: `url(${banner})`,
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                height: '100vh',
              }
            : {
                backgroundImage: `url(${banner})`,
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                height: '100vh',
              }
        }
        className="bg-img  d-none d-md-block"
      >
        <Container>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br /> <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <h1
            style={{
              color: 'white',
              textShadow: '1px 1px #000000',
              lineHeight: '1',
              fontSize: '70px',
            }}
            className="text-left ml-5 pl-5 test textShadow"
          >
            {t('Customize ')}
            <br />
            {t('your Iran Journey ')}
          </h1>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </Container>
      </div>

      <Container>
        <p
          style={{
            fontSize: '45px',
            lineHeight: '1',
          }}
          className="text-center mt-5 test"
        >
          {t('Custom Tailor-Made Iran Tours & Packages')}
        </p>

        <p className="text-left mt-3">
          {t(
            'TIMNAK customized tours don’t come out from our library and archives, every detail and aspects will be tailor-made around your personal interests. Our experience tells you how to travel in order to be under the fatigue curve, our knowledge in touring in IRAN, Safety and Passive defense grounds will be at your service. Designed Iran Journey through customization procedure will be fits within your budget and your dreams about IRAN and Persia. '
          )}{' '}
          .
        </p>

        <p className="text-left">
          {t(
            'Our specialists and assisting agents have traveled to these destinations, not only listing highlights to catch your eyes, they consider firsthand information and tour operation details to give you the unique experiences that others may miss! '
          )}
        </p>

        <p className="text-left">
          {t(
            'Traveling with TIMNAK, is beyond your preconception, merging into a universe of culture, lifestyle and knowledge. Over a decade experience in successful Tour Operating in IRAN, with thousands of extremely satisfied customers! '
          )}{' '}
        </p>

        <p className="text-left">
          {t('We pride ourselves on the fact that TIMNAK hold a strong connection to the local destinations. ')}
        </p>

        <p className="text-left">
          {t('Tailor-made Iran Journeys are our specialty and most popular service among other tours. ')}
        </p>

        <p className="text-left">
          {t('Let our expert assisting agents create the perfect Tailor-Made itinerary for you! ')}
        </p>

        <h2 className="mt-3">{t('How it works? ')}</h2>
        <p className="text-left">
          • {t('Your assisting agent will first listen to you about your dreams. ')}
          <br />• {t('The general Itinerary will be shaped around your interests and wishes. ')}
          <br />•{' '}
          {t(
            'We will talk to you about your preferred style of accommodation, as there are wide range of opportunities, boutique hotels, village stay, camping, luxury or normal nice 4 stars! '
          )}{' '}
          <br /> •{' '}
          {t(
            'TIMNAK will advise and book the best pre-arranged transportation via Air, Rail, Sea private drivers etc. '
          )}{' '}
          <br /> •{' '}
          {t(
            'You will have free days to be on your own schedule, personal activity or recreation, but please mention it to your assisting agent if you want.  '
          )}
          <br />• {t('You will have one assisting agent to take care your application from the beginning to the end. ')}{' '}
          <br /> •{' '}
          {t(
            'We have been in SHIRAZ since 2005, indeed the place of birth of founder and CEO of the company, Mr. TIMNAK. '
          )}
        </p>

        <p className="text-left">{t('It is easy to book your vacation package with us: ')}</p>
        <p className="text-left">
          {t(
            'You can fill the form below and wait until one of our agents will back to you OR we encourage you to create an account and follow up your request through the designated procedure. '
          )}
        </p>
      </Container>

      <Container>
        <Row className="mt-5">
          <Col xs={6} md={{ span: 2, offset: 1 }}>
            <div>
              <img className="container" alt="" src={c9} />
              <p className="px-2">{t('100% tailored to you and your interests ')}</p>
            </div>
          </Col>
          <Col xs={6} md={2}>
            <div>
              <img className="container" alt="" src={c3} />
              <p className="px-2">{t('Many possible itineraries. ')}</p>
            </div>
          </Col>{' '}
          <Col xs={6} md={2}>
            <div>
              <img className="container" alt="" src={c10} />
              <p className="px-2">{t('Fast and Free Quotes ')}</p>
            </div>
          </Col>{' '}
          <Col xs={6} md={2}>
            <div>
              <img className="container" alt="" src={c7} />
              <p className="px-2">{t('Custom Design, Tailor-made Tours ')}</p>
            </div>
          </Col>{' '}
          {!isMobile && (
            <Col xs={6} md={2}>
              <div>
                <img className="container" alt="" src={c8} />
                <p className="px-2">{t('24/7 In-Country Support! ')}</p>
              </div>
            </Col>
          )}
        </Row>

        <Row className="mt-5">
          <Col xs={6} md={{ span: 2, offset: 1 }}>
            <div>
              <img className="container" alt="" src={c1} />
              <p className="px-2">{t('No stress; we take care of everything ')}</p>
            </div>
          </Col>
          <Col xs={6} md={2}>
            <div>
              <img className="container" alt="" src={c4} />
              <p className="px-2">{t('Handpicked Hotels and Services ')}</p>
            </div>
          </Col>{' '}
          <Col xs={6} md={2}>
            <div>
              <img className="container" alt="" src={c6} />
              <p className="px-2">{t('We are flexible with your demands ')}</p>
            </div>
          </Col>{' '}
          <Col xs={6} md={2}>
            <div>
              <img className="container" alt="" src={c5} />
              <p className="px-2">{t('Great Local Guides ')}</p>
            </div>
          </Col>{' '}
          <Col xs={6} md={2}>
            <div>
              <img className="container" alt="" src={c2} />
              <p className="px-2">{t('Flights, accommodation and Transportation ')}</p>
            </div>
          </Col>
          {isMobile && (
            <Col xs={6} md={2}>
              <div>
                <img className="container" alt="" src={c8} />
                <p className="px-2">{t('24/7 In-Country Support! ')}</p>
              </div>
            </Col>
          )}
        </Row>
      </Container>

      <div className="mt-5 pt-5 container  pb-4" style={{ background: '#d4d4d4', color: 'black' }}>
        <Form className="mr-4">
          {show && (
            <Form.Group as={Row} className="tw-mb-4">
              <Col xs={2} />

              {show_message && (
                <Overlay target={target.current} show={show} placement="top">
                  {({ placement, arrowProps, show: _show, popper, ...props }) => (
                    <div
                      className="col-sm-3 px-1"
                      {...props}
                      style={{
                        backgroundColor: 'white',
                        padding: '2px 10px',
                        color: 'black',
                        background: '#FFC900',
                        fontSize: '15px',
                        borderRadius: 3,
                        ...props.style,
                      }}
                    >
                      <button
                        style={{
                          background: 'transparent',
                          border: 'none',
                        }}
                        className="btn btn-light pull-right"
                        onClick={() => setShowMessage(false)}
                      >
                        X
                      </button>
                      {t(
                        'We have attached the code of your desired itinerary to this form … Let us know your otherdreams, requests and preferred changes then submit the form. '
                      )}
                    </div>
                  )}
                </Overlay>
              )}

              <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
                {t('Trip code ')}
              </Form.Label>
              <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '6' }}>
                <Form.Control
                  // isValid={validname === true}
                  ref={target}
                  onChange={(e) => setTripCode(e.target.value)}
                  value={trip_code}
                  type="text"
                  placeholder="trip_code"
                />
              </Col>
            </Form.Group>
          )}

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2}></Col>

            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Name ')}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '6' }}>
              <Form.Control
                isValid={validname === true}
                onChange={(e) => setName(e.target.value.replace(/[0-9#<>~^{}\[\]]/, ''))}
                value={name}
                type="text"
                placeholder={t('Name ')}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2}></Col>

            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Email ')}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '6' }}>
              <Form.Control
                isValid={validemail === true}
                onChange={(e) => setEmail(e.target.value.replace(/[#<>~^{}\[\]]/, ''))}
                type="email"
                value={email}
                placeholder={t('Email ')}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2} />

            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Nationality ')}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '6' }}>
              <CountryDropdown
                value={nationality}
                onChange={(val) => selectCountry(val)}
                //style={validnationality ? { border: '1px solid #28af45' } : {}}
                classes="form-control"
                whitelist={[
                  'AL',
                  'AR',
                  'AM',
                  'AU',
                  'AT',
                  'AZ',
                  'BH',
                  'BY',
                  'BE',
                  'BA',
                  'BR',
                  'BG',
                  'CA',
                  'CL',
                  'CN',
                  'CO',
                  'HR',
                  'CY',
                  'CZ',
                  'DK',
                  'EG',
                  'EE',
                  'FJ',
                  'FI',
                  'FR',
                  'GE',
                  'DE',
                  'GH',
                  'GR',
                  'HK',
                  'HU',
                  'IS',
                  'IN',
                  'ID',
                  'IQ',
                  'IE',
                  'IL',
                  'IR',
                  'IT',
                  'JP',
                  'JO',
                  'KZ',
                  'KR',
                  'KW',
                  'KG',
                  'LV',
                  'LB',
                  'LI',
                  'LT',
                  'LU',
                  'MO',
                  'MK',
                  'MG',
                  'MY',
                  'MV',
                  'ML',
                  'MT',
                  'MX',
                  'MC',
                  'MN',
                  'MA',
                  'MM',
                  'NA',
                  'NP',
                  'NL',
                  'NZ',
                  'NO',
                  'OM',
                  'PE',
                  'PH',
                  'PL',
                  'PT',
                  'PR',
                  'QA',
                  'RO',
                  'RU',
                  'SA',
                  'RS',
                  'SG',
                  'SK',
                  'SI',
                  'ZA',
                  'ES',
                  'SE',
                  'CH',
                  'TW',
                  'TJ',
                  'TH',
                  'TN',
                  'TR',
                  'TM',
                  'UA',
                  'AE',
                  'GB',
                  'US',
                  'UZ',
                  'VN',
                ]}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2} />

            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Tel ')}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '6' }}>
              <PhoneInput
                inputStyle={validtel ? { border: '1px solid #28af45', width: '100%' } : { width: '100%' }}
                buttonStyle={validtel ? { border: '1px solid #28af45' } : {}}
                country={countrynumber}
                value={tel}
                onChange={(phone) => setTel(phone)}
              />{' '}
              {tel && !validtel && (
                <div className="text-danger small mt-2">
                  {t('Please enter a valid phone number for the selected country.')}
                </div>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2}></Col>

            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Traveling month ')}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '6' }}>
              <Form.Control
                style={validtravelingmonth ? { border: '1px solid #28af45' } : {}}
                onChange={(e) => setTravelingMonth(e.target.value.replace(/[0-9#<>~^{}\[\]]/, ''))}
                as="select"
              >
                <option disabled selected>
                  {t('select month')}
                </option>
                <option value="Jan">January</option>
                <option value="Feb">February</option>
                <option value="Mar">March</option>
                <option value="Apr">April</option>
                <option value="May">May</option>
                <option value="Jun">June</option>
                <option value="Jul">July</option>
                <option value="Aug">August</option>
                <option value="Sep">September</option>
                <option value="Oct">October</option>
                <option value="Nov">November</option>
                <option value="Dec">December</option>
              </Form.Control>{' '}
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2}></Col>

            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Duration ')}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '2' }}>
              <InputGroup className="mb-3">
                <InputGroup.Text>
                  <Button
                    style={{
                      zIndex: 0,

                      background: '#521231',
                      border: '1px solid #521231',
                    }}
                    onClick={() => {
                      counter2 !== 5 && setCounter2(counter2 - 1);
                    }}
                  >
                    -
                  </Button>
                </InputGroup.Text>
                <FormControl
                  onChange={(e) => {
                    if (parseInt(e.target.value) <= 30) {
                      setCounter2(parseInt(e.target.value.replace(/[#<>~^{}\[\]]/, '')));
                    }
                  }}
                  style={{ textAlign: 'center' }}
                  value={counter2}
                  aria-describedby="basic-addon1"
                  max="30"
                  // onKeyUp={(e) => {
                  //   e.target.value > 3 && setCounter2(null);
                  // }}
                />
                <InputGroup.Text>
                  <Button
                    style={{
                      zIndex: 0,

                      background: '#521231',
                      border: '1px solid #521231',
                    }}
                    className="btn-dark"
                    onClick={() => {
                      counter2 !== 30 && setCounter2(counter2 + 1);
                    }}
                  >
                    +
                  </Button>
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2}></Col>

            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Group size ')}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '2' }}>
              <InputGroup className="mb-3">
                <InputGroup.Text>
                  <Button
                    style={{
                      zIndex: 0,

                      background: '#521231',
                      border: '1px solid #521231',
                    }}
                    className="btn-dark"
                    onClick={() => {
                      counter !== 1 && setCounter(counter - 1);
                    }}
                  >
                    -
                  </Button>
                </InputGroup.Text>
                <FormControl
                  onChange={(e) => {
                    if (parseInt(e.target.value) <= 30) {
                      setCounter(parseInt(e.target.value.replace(/[#<>~^{}\[\]]/, '')));
                    }
                  }}
                  style={{ textAlign: 'center' }}
                  value={counter}
                  aria-describedby="basic-addon1"
                  max="30"
                />
                <InputGroup.Text>
                  <Button
                    style={{
                      zIndex: 0,

                      background: '#521231',
                      border: '1px solid #521231',
                    }}
                    className="btn-dark"
                    onClick={() => {
                      counter !== 100 && setCounter(counter + 1);
                    }}
                  >
                    +
                  </Button>
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2}></Col>

            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Level of accommodation ')}{' '}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '6' }}>
              <Form.Control
                style={validaccommodation ? { border: '1px solid #28af45' } : {}}
                onChange={(e) => setAccommodation(e.target.value.replace(/[#<>~^{}\[\]]/, ''))}
                as="select"
              >
                <option disabled selected>
                  {t('select level')}
                </option>
                {/* <option value="N">Not specified</option>
                <option value="R">Rural house</option>
                <option value="E">Eco lodge </option> */}
                {/* <option value="Tent">Tent</option>
                <option value="Guesthouse">Guesthouse</option> */}
                {/* <option value="1">Hotel *</option>
                <option value="2">Hotel **</option> */}
                <option value="3">Hotel ***</option>
                <option value="4">Hotel ****</option>
                <option value="5">Hotel *****</option>
              </Form.Control>{' '}
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="tw-mb-4">
            <Col xs={2}></Col>
            <Form.Label className="font-weight-bold" column xs={isMobile ? '7' : '2'}>
              {t('Your Message ')}
            </Form.Label>
            <Col xs={isMobile ? { span: '9', offset: '2' } : { span: '6' }}>
              <Form.Control
                isValid={validmessage === true}
                onChange={(e) => setMessage(e.target.value.replace(/[#<>~^{}\[\]]/, ''))}
                as="textarea"
                value={message}
                rows={6}
                placeholder={t('Your Message ')}
              />
            </Col>
          </Form.Group>
        </Form>
        <Row className="mt-3">
          <Col xs={{ span: 4, offset: 7 }} md={{ span: 2, offset: 9 }}>
            <a style={{ textDecoration: 'none' }} href="#">
              <Button
                disabled={checkValids() || isSubmitting}
                onClick={(e) => submitCustomtour(e)}
                style={
                  checkValids() || isSubmitting
                    ? {
                        background: '#5e0832',
                        borderColor: '#5e0832',
                        fontSize: '17px',
                        fontWeight: 'bold',
                        cursor: 'not-allowed',
                        textDecoration: 'none',
                      }
                    : {
                        background: '#5e0832',
                        borderColor: '#5e0832',
                        fontSize: '17px',
                        fontWeight: 'bold',
                      }
                }
                className="btn-dark btn-block"
                type="submit"
              >
                {isSubmitting ? <Spinner size="sm" animation="border" /> : t('Submit ')}
              </Button>
            </a>
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey="6Le95fgUAAAAADD5TOzPmqiX-IrErnTrqS6ABjUx"
              //onChange={onChange}
            />
          </Col>
        </Row>
      </div>

      <div className="tw-mb-12">
        <Section3 />
      </div>
      <Toast
        show={showSuccessToast}
        onClose={() => setShowSuccessToast(false)}
        autohide
        delay={5000}
        className="position-fixed"
        style={{ right: '20px', bottom: '20px', zIndex: 1060 }}
      >
        <Toast.Header closeButton>
          <strong className="me-auto">{t('Form submitted')}</strong>
        </Toast.Header>
        <Toast.Body className="bg-success text-white">{t('Your form has been submitted successfully.')}</Toast.Body>
      </Toast>
    </div>
  );
};

export default Client;
